import React from 'react';
import { Box, TextField, IconButton, Tooltip } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from 'react-i18next';
import { inputFormStyles } from '../../styles/qaStyles';

/**
 * QA 입력 폼 컴포넌트 (데스크톱/모바일 버전)
 * @param {object} props - 컴포넌트 props
 * @param {string} props.qaInput - QA 입력값
 * @param {function} props.setQaInput - QA 입력값 설정 함수
 * @param {boolean} props.qaLoading - QA 로딩 상태
 * @param {function} props.handleSubmit - 폼 제출 핸들러
 * @returns {JSX.Element} - QA 입력 폼
 */
const QAInputForm = ({ qaInput, setQaInput, qaLoading, handleSubmit }) => {
  const { t } = useTranslation();

  const inputProps = {
    endAdornment: (
      <IconButton
        type="submit"
        disabled={!qaInput.trim() || qaLoading}
        sx={inputFormStyles.iconButton}
        onClick={handleSubmit}
      >
        <SendIcon />
      </IconButton>
    )
  };

  return (
    <>
      {/* 데스크톱용 입력창 */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={inputFormStyles.desktop}
      >
        <TextField
          fullWidth
          size="small"
          placeholder={t('analyze.questionPlaceholder')}
          value={qaInput}
          onChange={(e) => setQaInput(e.target.value)}
          disabled={qaLoading}
          InputProps={inputProps}
          sx={inputFormStyles.textField}
        />
      </Box>

      {/* 모바일용 floating 입력창 */}
      <TextField
        component="form"
        onSubmit={handleSubmit}
        fullWidth
        size="small"
        placeholder={t('analyze.questionPlaceholder')}
        value={qaInput}
        onChange={(e) => setQaInput(e.target.value)}
        disabled={qaLoading}
        InputProps={inputProps}
        sx={{
          ...inputFormStyles.mobile,
          ...inputFormStyles.textFieldMobile
        }}
      />
    </>
  );
};

export default QAInputForm; 